import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { CopyToClipboardButton } from '@sorare/core/src/atoms/buttons/CopyToClipboardButton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconDuplicate } from '@sorare/core/src/atoms/icons/system/iconDuplicate.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { SocialShare } from '@sorare/core/src/components/user/SocialShare/index.tsx';
import {
  socialShareEventContext,
  socialShareEventName,
} from '@sorare/core/src/lib/events.ts';

import { useSquadInviteShare } from '#src/hooks/squad/useSquadInviteShare.ts';

const CodeField = styled(Horizontal)`
  flex: 1;
  background: var(--c-black);
  border: 1px dashed var(--c-nd-150);
  border-radius: var(--unit);
  padding: var(--unit) var(--double-unit);
  justify-content: space-between;
  position: relative;
`;

type Props = {
  joinSecret: string;
};

export const JoinSecretShare = ({ joinSecret }: Props) => {
  const { url, message } = useSquadInviteShare(joinSecret);

  return (
    <Horizontal gap={1}>
      <CodeField gap={1}>
        <BodyM color="var(--c-white)">{joinSecret}</BodyM>
        <CopyToClipboardButton textToCopy={joinSecret}>
          <FontAwesomeIcon icon={iconDuplicate} color="var(--c-white)" />
        </CopyToClipboardButton>
      </CodeField>
      <SocialShare
        url={url}
        message={message}
        trackingEventName={socialShareEventName.SHARE_SQUAD_INVITE}
        trackingEventContext={socialShareEventContext.SQUAD}
        renderButton={({ onClick }) => (
          <Button size="medium" color="secondary" onClick={onClick}>
            <FormattedMessage defaultMessage="Invite Friends" />
          </Button>
        )}
      />
    </Horizontal>
  );
};
